module.exports = __webpack_public_path__ + "static/media/Kiosk.9ff0954a.svg";